import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'graphql',
};

export const FORCE_DATA_STUBS = false;
export const FORCE_EMPTY_DATA_STUBS = false;

export class DataQueryApi extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  // @TODO: should this one query really handle every single data_query call?
  //  Specifically the ones being made over a time period could possibly be
  //  generalized into another query.
  //  Or is it fine and simmpler to just keep it this way even if we send and
  //  get back a bunch of nulls? Definitely makes it simple to just append to
  //  this one call and ignore nulls.
  processDataQuery({
    orgId,
    personId,
    dataQueryId,
    options = {},
  }) {
    const {
      merge = null,
      timeStart = null,
      timeEnd = null,
      relativeStart = null,
      relativeEnd = null,
    } = options;

    const query = `
      query DataQuery(
        $orgId: ID!,
        $personId: ID!,
        $dataQueryId: ID!,
        $merge: Boolean,
        $timeStart: String,
        $timeEnd: String,
        $relativeStart: String,
        $relativeEnd: String
      ) {
        processDataQuery(
          orgId: $orgId,
          personId: $personId,
          dataQueryId: $dataQueryId,
          merge: $merge,
          timeStart: $timeStart,
          timeEnd: $timeEnd,
          relativeStart: $relativeStart,
          relativeEnd: $relativeEnd
        ) {
          type
          count
          priority
          status
          jsonb_array_elements_src_country
          m_avg_seconds_to_status
          created
          id
          name
          resolution
          seconds_to_status
          summary
        }
      }
    `;

    const data = {
      orgId,
      personId,
      dataQueryId,
      merge,
      timeStart,
      timeEnd,
      relativeStart,
      relativeEnd,
    };

    return (
      super
        .get({ query, data })
        .then(({ processDataQuery }) => ({ data: processDataQuery }))
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/DataQueryAPI.js